"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RebateApi = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/*
 *@接口地址: https://pionex.atlassian.net/wiki/spaces/backend/pages/205325653/Pionex+Rebate+API+V2
 */
class RebateApiClass {
    constructor() { }
    getRequest(url, params) {
        return trade_utils_lib_1.ObservableUtils.getV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().rebateHost}/v2/${url}`, params, undefined, true);
    }
    postRequest(url, params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().rebateHost}/v2/${url}`, params, undefined, true);
    }
    /**
     * 返佣基础信息
     */
    rebateBaseFullGet() {
        return this.getRequest("rebate_full");
    }
    /**
     * 返佣数据统计
     */
    rebateStatGet() {
        return this.getRequest("rebate_stat");
    }
    /**
     * 返佣历史数据
     */
    rebateHistoryGet(params) {
        return this.getRequest("rebate_history", params);
    }
    /**
     * 我的邀请链接
     */
    rebateInviteLinkListGet() {
        return this.getRequest("invite_link_list");
    }
    /**
     * 我的邀请列表
     */
    rebateInviteUserListGet(params) {
        return this.getRequest("invite_user_list", params);
    }
    /**
     * 我的邀请码列表
     */
    shareCodeListGet() {
        return this.getRequest("share_code_list");
    }
    /**
     * 创建邀请码
     */
    createShareCodePost(params) {
        return this.postRequest("create_share_code", params);
    }
    /**
     * 邀请码更新
     */
    shareCodePut(params) {
        return this.postRequest("share_code_operation", params);
    }
    /**
     * 我绑定的邀请码信息
     */
    boundShareCodeInfoGet() {
        return this.getRequest("bound_share_code_info");
    }
    /**
     * 返佣记录
     */
    commissionRebatesGet(params) {
        return this.getRequest("commission/rebates", params);
    }
}
function RebateApi() {
    return new RebateApiClass();
}
exports.RebateApi = RebateApi;
